module.exports = __webpack_public_path__ + "files/e927014d4206932acb84fba1539d35b9.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Droid-Serif-regular.woff2
 ** module id = 849
 ** module chunks = 0
 **/